import classnames from 'classnames';
import { VODCSSModules } from 'shared/utils/wix-connect';

import { ClickableThumbnail } from 'widget/components/thumbnail/thumbnail';

import styles from './video-list-item.styl';


@VODCSSModules(styles)
export default class VideoListItem extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
    onClick: React.PropTypes.func,

    isPlaying: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    isLastInRow: React.PropTypes.bool,

    channelData: React.PropTypes.object,
    videoItem: React.PropTypes.object,

    width: React.PropTypes.number,
    height: React.PropTypes.number,
  };

  render() {
    const {
      className,
      channelData,
      videoItem,
      width,
      height,
      onClick,
      isSelected,
      isPlaying,
      isLastInRow,
    } = this.props;

    return (
      <div styleName="video-list-item"
           className={classnames(className, { [styles['is-last']]: isLastInRow })}
           style={{ width }}>
        <ClickableThumbnail width={width}
                            height={height}
                            onClick={onClick}
                            isSelected={isSelected}
                            nowPlaying={isSelected && isPlaying}
                            channelData={channelData}
                            videoItem={videoItem}
                            dataHook="videoListThumbWrapper" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/classic/components/videos/video-list-item/video-list-item.js